
window.addEventListener("load",function() {
   $(".custom_collapsible_tab_title_js").click(function () {
    toggle_coll(this);
  });
  // $(".custom-has-pop-wrapper").find("a").click(function(e) {
  //   e.preventDefault();
  //   $(this).parents(".custom-has-pop-wrapper").siblings(".custom-pop-wrapper").fadeIn()
  //   $("body").addClass("o-custom-pop")
  // })
  //  $(".custom-pop-close").click(function() {
  //   $(this).parents(".custom-pop-wrapper").fadeOut()
  //   $("body").removeClass("o-custom-pop")
  // })
})
document.querySelectorAll('.custom-has-pop-wrapper a').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const popWrapper = this.closest('.custom-has-pop-wrapper')
      .parentElement.querySelector('.custom-pop-wrapper');

    if (popWrapper) {
      popWrapper.classList.add('show')
      document.body.classList.add('o-custom-pop');
    }
  });
});

document.querySelectorAll('.custom-pop-close').forEach(function(closeBtn) {
  closeBtn.addEventListener('click', function() {
    const popWrapper = this.closest('.custom-pop-wrapper');
    if (popWrapper) {
      popWrapper.classList.remove('show')
      document.body.classList.remove('o-custom-pop');
    }
  });
});
function toggle_coll(e) {
  if (!$(e).parent().hasClass("open")) {
      $(e).siblings(".custom_collapsible_tab_container").slideDown()
    }else{
      $(e).siblings(".custom_collapsible_tab_container").slideUp()
    }
    $(e).parent().toggleClass("open")
}

  class customCardSwiper extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        setTimeout( () => this.initSwiper(), 0)
    }
    initSwiper() {
      let pagination = this.querySelector(".swiper-pagination")
        new Swiper(this.querySelector(".custom-card-swiper-container"),{
          slidesPerView: 1,
          spaceBetween: 5,
          pagination: {
            el: pagination,
          },
           lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
        })
    }
}
customElements.define("custom-card-swiper", customCardSwiper);
